<template>
    <div style="height: 100dvh">
        <NuxtPwaManifest />
        <NuxtLoadingIndicator />
        <NuxtRouteAnnouncer />
        <NuxtLayout>
            <Toast />

            <!-- Banner aggiornamento PWA (plugin @vite-pwa/nuxt) -->
            <div
                v-if="$pwa?.needRefresh"
                class="fixed bottom-24 left-1/2 -translate-x-1/2 bg-amber-600 text-white px-4 py-2 rounded shadow flex items-center gap-3 z-40"
            >
                <span class="text-sm">Nuovi contenuti disponibili.</span>
                <button
                    class="bg-white text-amber-700 px-2 py-1 rounded text-xs font-medium hover:bg-amber-100 transition"
                    @click="$pwa.updateServiceWorker()"
                >Aggiorna</button>
            </div>

            <!-- Banner aggiornamento Service Worker custom -->
            <SwUpdateBanner />

            <NuxtPage />
        </NuxtLayout>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePrimeVue } from 'primevue/config';

// Stato traduzioni
const translationObj = ref(null);
const { $pwa, $localStorage } = useNuxtApp();
const { setLocale } = useI18n();
const env = useRuntimeConfig();
const BASE_PROGETTO = env.public.base_progetto; // In caso serva altrove
const primevue = usePrimeVue();
const languages = [{ value: 'it' }, { value: 'en' }, { value: 'fr' }]; // eventuale uso futuro

onMounted(async () => {
    try {
        const response = await fetch('/languages/translation.json');
        translationObj.value = await response.json();
    } catch (error) {
        translationObj.value = null;
    } finally {
        await applyLanguage();
    }
});

async function applyLanguage() {
    const languageLocalStorage = $localStorage.getItem('selectedLanguage') || 'it';
    setTranslations(languageLocalStorage);
    await setLocale(languageLocalStorage);
}

function setTranslations(language) {
    const translations = translationObj.value?.[language];
    if (!translations) return;
    Object.assign(primevue.config.locale, translations);
}
</script>

<style scoped>
/* Potenziali stili locali aggiuntivi */
</style>
